/**
 * True when the user has asked the OS/browser to reduce motion.
 * Safe to call on the server, where it returns false.
 */
export default function prefersReducedMotion() {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
